$(".humbox").click(function () {
    $(this).toggleClass('active');
});


$(function(){
  $('.humbox').click(function(){
    $('.menu-area').toggleClass('active');
  });
});


/*VARY*/


$(".btn-box").click(function () {
    $(this).toggleClass('active');
});


$(function(){
  $('.btn-box').click(function(){
    $('.vary-area').toggleClass('active');
  });
});
